

exports.__esModule = true;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('components/xo-models/src/checkout/index');

var _angular = require('angular');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionLightbox', {
    tag: 'xo-currency-conversion-lightbox',
    template: _template2['default'],

    props: {
        isPrePlan: {
            type: 'str'
        },
        parentModel: {
            type: 'var'
        },
        token: {
            type: 'var'
        },
        doneFn: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            this.isPrePlanVal = true;
            if (!this.props.isPrePlan || this.props.isPrePlan !== 'true') {
                this.isPrePlanVal = false;
            }

            return {
                checkoutSession: this.props.isPrePlan ? undefined : _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            var _this = this;

            if (!this.models.ppconversion) {
                this.message = {
                    msgKeys: ['currencyOptions.noneSelected'],
                    type: 'error'
                };
                return;
            }

            _logger.$logger.info('checkout_fpti', { from: 'CURRENCY_CONVERSION', to: 'process_currency_conversion' });

            if (this.parentModel) {
                this.parentModel.onboard.card.ppconversion = this.models.ppconversion;
            }
            /*
             * This check cuts off flow to the updateConversion service call in postPlanUpdateConversionVendor function for:
             * 1. Pre-Planning (Non-Visa DCC) for both PAYPAL and VENDOR selections, since service call done on createXO
             * 2. Post-Plan (Visa DCC) PAYPAL selection, since no updateConversion call needed.
             * Only will allow Post-Plan (Visa DCC) VENDOR selection to go through to updateConversion call below.
             */
            if (this.isPrePlanVal || this.models.ppconversion === 'PAYPAL') {
                var dccType = this.isPrePlanVal ? 'nonvisa_dcc' : 'visa_dcc';
                var toState = 'process_' + this.models.ppconversion.toLowerCase() + '_conversion_' + dccType;
                _logger.$logger.info('checkout_fpti', { from: 'CURRENCY_CONVERSION', to: toState });

                this.closeModal();
                return;
            }

            var payload = {
                conversionType: this.models.ppconversion,
                planId: this.models.checkoutSession && this.models.checkoutSession.plan.id
            };

            var postPlanUpdateConversionVendor = function postPlanUpdateConversionVendor(_payload) {
                if (_payload.planId) {
                    _this.models.checkoutSession.fundingOptions.action('updateConversion', {

                        data: _payload,

                        success: function success(result) {
                            _logger.$logger.info('checkout_fpti', { from: 'CURRENCY_CONVERSION', to: 'process_vendor_conversion_visa_dcc' });
                            _this.closeModal();
                        },
                        error: function error() {
                            _this.message = {
                                msgKeys: ['genericError.genericError'],
                                type: 'error'
                            };
                            return;
                        },
                        contingency: function contingency() {
                            _this.message = {
                                msgKeys: ['genericError.genericError'],
                                type: 'error'
                            };
                            return;
                        }
                    });
                }
            };

            // Post-Plan Visa DCC call to update slection to VENDOR
            postPlanUpdateConversionVendor(payload);
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            _logger.$logger.info('checkout_fpti', { from: 'CURRENCY_CONVERSION', to: 'prepare_currency_conversion' });

            this.continueButton = _squid.$locale.content.get('common.payLabel');
            this.conversionOptions = {
                PAYPAL: 'PAYPAL',
                VENDOR: 'VENDOR'
            };

            this.locale = _squid.$locale;

            this.closeModal = function (event) {
                if (event) {
                    event.preventDefault();
                }

                var onComplete = _squid.$util.once(function () {
                    _logger.$logger.info('close_currency_conversion_lightbox');
                    return _this2.isPrePlanVal ? _this2.props.doneFn('close') : _this2.props.doneFn();
                });

                _this2.modalOpen = false;
                // Hook css transition completion event 'transitionend' to call onComplete function, guarentees best timing              
                $('#conversionSection .conversion').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function (e) {
                    $(_this2).off(e);
                    onComplete();
                });
                // transitionend event not supported fallback
                // if browser doesn't support transitionend event callback, we call onComplete after 350ms as fallback
                (0, _angular.$timeout)(onComplete, 350);
            };

            // Javascript for interstitial opening 
            (0, _angular.$timeout)(function () {
                _this2.modalOpen = true;
            });
        },
        populate: function populate() {
            var unformattedAmount = this.models.checkoutCart.get('purchase.amounts.total.amount');
            var merchantCurrencyCode = this.models.checkoutCart.get('purchase.amounts.total.currency_code');
            this.merchantTotal = (0, _squid.formatCurrency)(unformattedAmount, merchantCurrencyCode, false);

            if (this.models.checkoutSession) {
                // Post-Plan Case, Visa
                this.conversion = this.models.checkoutSession.plan.conversion;
                this.paypalConversionTotal = this.models.checkoutSession.get('plan.sources.0.amount.amount_formatted_currency');
            } else {
                // Pre-Plan Case, Non-Visa
                this.conversion = this.parentModel.onboard.card.currencyConvData;
                var convertedTotal = this.conversion.payment_amt;
                this.paypalConversionTotal = (0, _squid.formatCurrency)(convertedTotal.value, convertedTotal.currency, false);
            }

            if (!this.conversion.formattedFromStr || !this.conversion.formattedToStr) {
                this.conversion.formattedFromStr = truncateCurrencyConversionStr(this.conversion.from, this.conversion.from_amount);
                this.conversion.formattedToStr = truncateCurrencyConversionStr(this.conversion.to, this.conversion.to_amount);
            }

            this.models.ppconversion = 'PAYPAL';
            if (this.parentModel) {
                this.models.ppconversion = this.parentModel.onboard.card.ppconversion ? this.parentModel.onboard.card.ppconversion : 'PAYPAL';
            }
        }
    }
});

/* @params
    * fullStr: The full formatted currency conversion string returned from downstream service.
    * amtStr: Just the currency conversion amount portion of the full string returned from downstream.
    */

function truncateCurrencyConversionStr(fullStr, amtStr) {
    try {
        var fixedPrecision = Number(amtStr).toFixed(4);
        var formattedStr = fullStr.replace(amtStr, fixedPrecision);
        if (fixedPrecision == 0) {
            // eslint-disable-line
            throw new Error('Currency conversion truncation error encountered, defaulting to full unformatted currencyConversion string.');
        }
        return formattedStr;
    } catch (e) {
        _logger.$logger.warn('currency_conversion_error', {
            reason: 'Error formatting currency conversion data to formatted str in guest/currencyConversion/directive',
            error: e
        });
        return fullStr;
    }
}
_squid.$Component;

_squid.$locale;

_squid.formatCurrency;

_squid.$util;

_logger.$logger;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_angular.$timeout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/currencyConversion/directive.js
// module id = ./components/xo-guest-components/src/guest/currencyConversion/directive.js
// module chunks = 1